'use strict';

wbApp.filter('nonEmptyCollection', [function () {
    return function (input) {
         return input && input.length ? '\u2713' : '\u2718';
         //return input && input.lenght ? '\uf0c8' : '\uf096';
    }
}]);